import { render, staticRenderFns } from "./GroupItemEditor.vue?vue&type=template&id=3f0346af&"
import script from "./GroupItemEditor.vue?vue&type=script&lang=js&"
export * from "./GroupItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./GroupItemEditor.vue?vue&type=style&index=0&lang=scss&scooped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports